/** Delivery notes are not included on invoices. */
export function getInvoiceDeliveryNotes() {
  return '';
}

/** Equipment count recorded when the driver completed the job. */
export function getJobEquipmentCount(job) {
  if (!job) return null;
  if (job.equipment_count != null && job.equipment_count !== '') {
    return job.equipment_count;
  }
  const fromCompletion = job.delivery_completion?.equipment_count;
  if (fromCompletion != null && fromCompletion !== '') {
    return fromCompletion;
  }
  return null;
}
